import { render } from "./ViewStudentDTRDialog.vue?vue&type=template&id=e9a535e4&scoped=true"
import script from "./ViewStudentDTRDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentDTRDialog.vue?vue&type=script&lang=js"

import "./ViewStudentDTRDialog.vue?vue&type=style&index=0&id=e9a535e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a535e4"]])

export default __exports__